import $ from 'jquery';

// TODO: Move classnames to seprate file
const IS_ACTIVE = 'is-active';
const HAS_FOCUS = 'has-focus';

const inputKenticoInit = () => {
    $('.js-floating-label').each(function () {
        const $element = $(this);
        const $input = $('input', $element);
        const $select = $('select', $element);
        const $textarea = $('textarea', $element);

        const isSelect = !!$select.length > 0;
        const isTextarea = !!$textarea.length > 0;

        const isInputFilled = () => {
            if (isSelect) {
                return $select.find(':selected').text().length > 1;
            }

            if (isTextarea) {
                return $textarea.val().length > 0;
            }

            if ($input && $input.val()) {
                return $input.val().length > 0;
            }

            return false;
        };

        const floatLabel = () => {
            if (!isInputFilled() && !$element.hasClass(HAS_FOCUS)) {
                $element.removeClass(IS_ACTIVE);
            }
        };

        const onLabelClick = () => {
            $input.focus();
        };

        const focusIn = () => {
            $element.addClass(IS_ACTIVE);
            $element.addClass(HAS_FOCUS);
        };

        const focusOut = () => {
            $element.removeClass(HAS_FOCUS);

            floatLabel();
        };

        const handlePrefilledInput = () => {
            if (isInputFilled() && !isSelect) {
                $element.addClass(IS_ACTIVE);
            }
        };

        const init = () => {
            $element.on('focusin', focusIn);
            $element.on('focusout', focusOut);
            $element.on('input', floatLabel);
            $element.on('click', onLabelClick);
            handlePrefilledInput();
        };

        if ($element) {
            init();
        }
    });

    $('.js-password-toggle').each(function () {
        const $element = $(this);

        $element.on('click', function () {
            const input = $(this).prev()[0];
            const eye = $(this)
                .children()
                .eq(0);
            const eyeOff = $(this)
                .children()
                .eq(1);

            if (input.type === 'password') {
                $(input).attr('type', 'text');
                $(eyeOff).addClass('u-d-none');
                $(eye).removeClass('u-d-none');
            } else {
                $(input).attr('type', 'password');
                $(eyeOff).removeClass('u-d-none');
                $(eye).addClass('u-d-none');
            }
        });
    });
};

$(() => {
    inputKenticoInit();
});

//make the script available for classic JS scripts on the HTML page
if (typeof window.allnex === "undefined") {
    window.allnex = {};
}
window.allnex.inputKenticoInit = inputKenticoInit;
